import { defineComponent } from 'vue';
import axios, { AxiosResponse } from 'axios';
import DCApp from "./../Shared/App.vue";
import dcautocomplete from "./../Shared/dcautocomplete.vue";
import { createPinia } from 'pinia';

import * as Vue from 'vue';

const mixin = defineComponent({
    data() {
        return {
            urlconstructeur: ""
        };
    },
    mounted() {
    },
    methods:{

     SetUrlCategorie(url: string) {
        this.urlconstructeur = url;
    },

     /*SearchConstructeur(url: string, data: string) {
        axios.post<string>(url, { query: data }).then(function (response: AxiosResponse<string>) {
            if (response.data !== null) {
                $("#blocconst").html(response.data);
            }
        });
    },*/

     ConstructeursResults(input: string) {
        let url: string = "/api/v1.0/drivers/SearchConstructeur?query=" + input;
        return url;
    },

        ConstructeursDisplay(result: any) {
        return result.label;
    },

     ConstructeursSelected(selectitem: any) {
        let url = this.urlconstructeur.replace("-1", selectitem.value).replace("-2", selectitem.display);
        location.href = url;
    }
}
});


export class AccueilComponent {







    public Init() {
        DCApp.mixins = [mixin];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
       //app.mixin(mixin);
        app.component("autocomplete", dcautocomplete);
        app.mount('#rootpage');
    }
}

(<any>(window)).AccueilComponent = function () { return new AccueilComponent(); };